// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__21wXn","identity":"Header_identity__1ljqP","image":"Header_image__2UhJq","info":"Header_info__1yed0"};